import { toast } from "react-toastify";
import Cookies from "js-cookie";


export const notify = (message, type) => {
  toast[type](message, {
    position: "top-right",
    autoClose: 2000,
  });
};

export const setToken = (token, email, role) => {
  const expiryTime = 4 * 60 * 60 * 1000; // 4 hours in milliseconds
  Cookies.set("token", token, { expires: expiryTime / (24 * 60 * 60 * 1000) });
  Cookies.set("tokenExpiry", Date.now() + expiryTime);
  Cookies.set("email", email, { secure: true, sameSite: "strict" });
  Cookies.set("role", role, { secure: true, sameSite: "strict" });
};

export const isLoggedIn = () => {
  const token = Cookies.get("token");
  const tokenExpiry = Cookies.get("tokenExpiry");

  if (token && tokenExpiry) {
    const isExpired = Date.now() > parseInt(tokenExpiry, 10);

    if (isExpired) {
      Cookies.remove("token");
      Cookies.remove("tokenExpiry");
      return false;
    }

    return true;
  }

  return false;
};

export const handleLogout = () => {
  Cookies.remove("token");
  Cookies.remove("email");
  Cookies.remove("role");
};

export const getToken = () => {
  return Cookies.get("token");
};

export const getEmail = () => {
  return Cookies.get("email");
};

export const getRole = () => {
  return Cookies.get("role");
};

export const downloadCSV = () => {
  const table = document.getElementById("data-table");
  let csv = [];
  for (let row of table.rows) {
    let cols = [];
    for (let cell of row.cells) {
      cols.push(cell.innerText);
    }
    csv.push(cols.join(","));
  }
  const csvFile = new Blob([csv.join("\n")], { type: "text/csv" });
  const downloadLink = document.createElement("a");
  downloadLink.href = URL.createObjectURL(csvFile);
  downloadLink.download = "data.csv";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export const parseSearchText = (searchText) => {
  if (!searchText) return [];
  const matches = searchText.match(/("[^"]+"|\b\w+\b)/g);
  return matches ? matches.map((term) => term.replace(/"/g, "")) : [];
};
const escapeHtml = (text) => {
  console.log("text before processing:", text);

  // Remove the entire span tag but keep its content, including any inner tags like <Phone_Number>, <PERSON>, etc.
  return text.replace(/<span[^>]*>(.*?)<\/span>/gi, '$1');
};
export const highlightEntities = (
  anonymizedText,
  findings,
  selectedEntities,
  reductionType = "highlight"
) => {
  let highlightedText = anonymizedText;
  if (reductionType === "replace") {
    const anonymizedText2 = anonymizedText
    console.log(anonymizedText2)
    return anonymizedText2
  }
  findings.forEach((finding) => {
    const entityTag = `<${finding.entity_type}>`;
    const replacement =
      selectedEntities.includes(finding.entity_type) &&
      finding.highlight === true
        ? `<span class="${reductionType}">${finding.text}</span>`
        : `<span class="no-highlight">${finding.text}</span>`;
    highlightedText = highlightedText.replace(entityTag, replacement);
  });
  console.log(highlightedText)
  return highlightedText;

};

export const highlightSearchText2 = (
  text,
  searchTerms,
  reductionType = "highlight"
) => {
  window.toggleHighlight = toggleHighlight;
  if (searchTerms.length === 0) {
    return text;
  }

  let highlightedText = text;

  searchTerms.forEach((term) => {
    const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`\\b${escapedTerm}\\b`, "gi");

    highlightedText = highlightedText.replace(
      regex,
      `<span class="highlight-search" onClick="toggleHighlight(this)">$&</span>`
    );
  });

  return highlightedText;
};


function toggleHighlight(span) {
  if (span.classList.contains("highlight-search")) {
    span.classList.remove("highlight-search");
    span.classList.add("unhighlight");
  } else {
    span.classList.remove("unhighlight");
    span.classList.add("highlight-search");
  }
}
export const highlightSearchText = (
  text,
  searchTerms,
  reductionType = "highlight"
) => {
  window.toggleHighlight = toggleHighlight;
  if (searchTerms.length === 0) {
    return text;
  }

  let highlightedText = text;
  searchTerms.forEach((term) => {
    const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`\\b${escapedTerm}\\b`, "gi");

    if (reductionType === "mask") {
      highlightedText = highlightedText.replace(
        regex,
        `<span class="mask" >${term}</span>`
      );
    } else if (reductionType === "highlight") {
      highlightedText = highlightedText.replace(
        regex,
        `<span class="highlight-search" onClick="toggleHighlight(this)">$&</span>`
      );
    } else if (reductionType === "replace") {
      highlightedText = highlightedText.replace(regex, term);
    }
  });
  return highlightedText;
};
// export const highlightSearchText = (text, searchTerms, reductionType = "highlight", ineer) => {
//   console.log("Reduction Type:", reductionType);
//   console.log(ineer)
//   window.toggleHighlight = toggleHighlight;

//   if (searchTerms.length === 0) {
//     return text;
//   }

//   console.log("Original Text:", text);
//   console.log("Search Terms:", searchTerms);

//   let highlightedText = text;

//   // Sort search terms by length to handle longer terms first
//   searchTerms.sort((a, b) => b.length - a.length);

//   searchTerms.forEach((term) => {
//     // Escape special characters in the term
//     const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
//     console.log("Escaped Term:", escapedTerm);
  
//     // Create a regex that matches the entire search term, allowing for spans
//     const termWords = escapedTerm.split(/\s+/).map(word => `(?:<[^>]*>)*${word}(?:<[^>]*>)*`).join('\\s*');
//     const spanRegex = new RegExp(termWords, 'gi');
//     console.log("Span Regex:", spanRegex);

//     // Apply the reduction type logic
    
//     highlightedText = highlightedText.replace(spanRegex, (match) => {
//       console.log("Match:", match);
//       // Remove existing highlight, no-highlight, and highlight-search classes
//       const cleanText = match.replace(/<span[^>]*class="[^"]*(?:highlight|no-highlight|highlight-search|mask|unhighlight)[^"]*"[^>]*>(.*?)<\/span>/gi, '$1');
//       // Determine the class based on reductionType
//       const highlightClass = reductionType === "mask" ? "mask" : "highlight-search";
//       return `<span class="${highlightClass}" onClick="toggleHighlight(this)">${cleanText}</span>`;
//     });
//   });

//   // Log the final highlighted text for debugging
//   console.log("Highlighted Text:", highlightedText);
//   return highlightedText;
// };







// export const highlightLastSearchTerm = (
//   text,
//   searchTerms,
//   reductionType = "highlight"
// ) => {
//   window.toggleHighlight = toggleHighlight;
//   if (searchTerms.length === 0) {
//     return text;
//   }

//   console.log("text", text);
//   console.log("searchTerms", searchTerms);

//   let highlightedText = text;

//   // Get the last search term
//   const lastTerm = searchTerms[searchTerms.length - 1];
//   const escapedTerm = lastTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
//   console.log("escapedTerm", escapedTerm);

//   // Normalize the text by removing existing spans
//   const normalizedText = text.replace(/<\/?span[^>]*>/g, '');
//   console.log("normalizedText", normalizedText);

//   // Create a regex that matches the entire search term, allowing for spans and special characters
//   const termWords = escapedTerm.split(' ').map(word => `(?:<[^>]*>)*${word}(?:<[^>]*>)*`).join('\\s*');
//   const spanRegex = new RegExp(termWords, 'gi');
//   console.log("spanRegex", spanRegex);

//   // Apply the new highlight on the normalized text
//   highlightedText = normalizedText.replace(spanRegex, (match) => {
//     console.log("match after cleaning", match);
//     return `<span class="highlight-search" onClick="toggleHighlight(this)">${match}</span>`;
//   });

//   // Log the final highlighted text for debugging
//   console.log("highlightedText", highlightedText);
//   return highlightedText;
// };











export const parseReadyText = (text, reductionType = "highlight") => {
  if (!text) return [];
  const result = [];
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(text, "text/html");
  const childNodes = htmlDoc.body.childNodes;

  childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      result.push({ text: node.textContent });
    } else if (
      node.nodeType === Node.ELEMENT_NODE &&
      node.nodeName === "SPAN"
    ) {
      if (node.classList.contains("highlight-search")) {
        result.push({
          text: node.textContent,
          background: "lightgreen",
        });
      } else if (node.classList.contains("mask")) {
        result.push({
          text: node.textContent,
          background: "black",
          color: "black",
        });
      } else if (node.classList.contains("highlight")) {
        result.push({
          text: node.textContent,
          background: "yellow",
        });
      } else {
        result.push({ text: node.textContent });
      }
    }
  });

  return result;
};

export const generateDocContent = (
  initialText,
  reductionType = "highlight"
) => {
  const parsedText = parseReadyText(initialText, reductionType);
  return parsedText.map((part) => {
    if (typeof part === "string") {
      return { text: part };
    } else {
      return {
        text: part.text,
        background: part.background || undefined,
        color: part.color || undefined,
      };
    }
  });
};
